import React from 'react';
import { Eye, EyeOff } from 'lucide-react';

function VisibilityIndicator({ visibility = 'private', size = 16, className = '' }) {
  const isPublic = visibility === 'public';
  const label = isPublic ? 'Public' : 'Private';
  const Icon = isPublic ? Eye : EyeOff;

  return (
    <div
      className={`visibility-indicator ${isPublic ? 'public' : 'private'} ${className}`.trim()}
      data-tooltip={label}
      aria-label={label}
    >
      <Icon style={{ width: size, height: size }} />
    </div>
  );
}

export default VisibilityIndicator;
